import Banner from './Banner';
import ServicesPopUp from './ServicesPopUp';
import ListOfServices from './ListOfServices';
import Technologies from './Technologies';

export { Banner };
export { ServicesPopUp };
export { ListOfServices };
export { Technologies };
